import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

export default function KonaseemaMapAndReach() {
  const { reach: konaseemaReach, mapEmbed: konaseemaMapEmbed } = useKonaseemaGuide();
  return (
    <section className="bg-secondary-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Getting Here
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            Plan Your Route to the Delta
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 items-stretch">
          <Reveal className="lg:col-span-7">
            <div className="h-full min-h-[22rem] rounded-lg overflow-hidden border border-secondary-200 bg-background-100">
              <iframe
                title="Konaseema location map"
                src={konaseemaMapEmbed}
                className="w-full h-full min-h-[22rem]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              ></iframe>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="h-full bg-background-50 rounded-lg border border-secondary-200 p-7 md:p-8">
              <h3 className="font-heading text-2xl text-foreground-950 font-semibold">
                How to Reach Konaseema
              </h3>
              <div className="mt-6 space-y-5">
                {konaseemaReach.map((item) => (
                  <div key={item.mode} className="flex items-start gap-4">
                    <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                      <i className={`${item.icon} text-xl`}></i>
                    </span>
                    <div>
                      <p className="font-semibold text-foreground-900">{item.mode}</p>
                      <p className="text-sm text-foreground-600 leading-relaxed mt-1">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}